Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var breakpoints = ['40em', '52em', '64em'];
var nativeBreakpoints = [550, 3000];
var colors = {
  border: {
    main: '#dddddd',
    accent: '#ff0000'
  },
  background: {
    main: '#fff',
    secondary: '#f5f5f5',
    alternate: '#000',
    halfTransparent: 'rgba(0, 0, 0, 0.5)'
  },
  font: {
    main: '#000',
    secondary: '#b2b2b2',
    alternate: '#fff',
    enclosed: '#fff'
  },
  highlight: {
    main: '#ff0000',
    secondary: '#7da1d0'
  },
  form: {
    WIN: '#38761d',
    DRAW: '#b2b2b2',
    LOST: '#e06666'
  },
  shadows: {
    main: '#024'
  },
  switch: {
    on: '#7da1d0',
    off: '#e5e5e5'
  },
  calendar: {
    text: '#000',
    today: '#ff0000'
  },
  tabHighlight: {
    main: '#000'
  },
  black: '#000',
  white: '#fff',
  standings_qualify: {
    champions_league: '#38761d',
    champions_league_quali: '#93c47d',
    europa_league: '#577dab',
    europa_league_quali: '#7da1d0',
    way_down_relegation: '#f8e832',
    way_down: '#e06666'
  },
  formation: {
    grass: '#a6d690',
    lines: '#fff'
  },
  YELLOW_CARD: '#f8e833',
  RED_CARD: '#ff0000',
  transfer: {
    standard: '#000',
    leaving: '#ff0000',
    joining: '#00ff00'
  }
};
var space = [0, 4, 8, 16, 24, 32, 64, 128, 256, 512];
var fontSizes = ['8px', '13px', '18px', '40px'];
var lineHeights = ['40px', '24px', '20px', '16px'];
var fontWeights = {
  normal: 500,
  bold: 700
};
var letterSpacings = {
  normal: 'normal',
  caps: '0.25em'
};
var radii = [0, 2, 4, 8];
var borders = [0, '1px solid', '2px solid'];
var shadows = ["0 1px 2px 0 " + colors.shadows.main, "0 1px 4px 0 " + colors.shadows.main, "2px 2px 0 " + colors.border.main];
var theme = {
  breakpoints: breakpoints,
  nativeBreakpoints: nativeBreakpoints,
  colors: colors,
  space: space,
  fontSizes: fontSizes,
  lineHeights: lineHeights,
  fontWeights: fontWeights,
  letterSpacings: letterSpacings,
  radii: radii,
  borders: borders,
  shadows: shadows
};
var _default = theme;
exports.default = _default;